import { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { Accordion } from "../../../main/components/accordion/Accordion";

import AddUGForm from "./AddUGForm";
import { PostUG, PostUsina, Usina } from "../types";
import { usinasApi } from "../../../services/api";
import { ugsToPostUgs } from "../ugsMapper";

interface AdicionarUGProps {
  onClose: () => void;
  usina: Usina | null;
  onMount: () => void;
  isEditing: boolean;
}

const AdicionarUG: React.FC<AdicionarUGProps> = ({
  onClose,
  usina,
  onMount,
  // isEditing,
}) => {
  const path = window.location.pathname;
  const usinaId = path.split("/")[2];

  const [showDetails, setShowDetails] = useState<boolean>(false);
  const toggleDetails = () => {
    console.log("ADD UG", usina);
    setShowDetails(!showDetails);
    console.log("showDetails:", !showDetails);
  };

  useEffect(() => {
    onMount();
  }, []);

  const handleFormValues = async (ug: PostUG) => {
    console.log("UG criada a partir do formulário:", ug);

    try {
      // Obtém as unidades geradoras existentes da usina
      const existingUGs = ugsToPostUgs(usina?.uGs) || [];

      // Adiciona a nova unidade geradora à lista existente
      const updatedUGs = [...existingUGs, ug];

      // Cria um objeto com a lista atualizada de unidades geradoras
      const newUG: Partial<PostUsina> = {
        uGs: updatedUGs,
      };

      // Envia a solicitação para a API com a lista atualizada
      const response = await usinasApi.patchUsina(usinaId, newUG);

      console.log("Resposta da API:", response);

      onClose();
      onMount();

      // Recarrega a página após salvar os dados
      // window.location.reload();
    } catch (error) {
      console.error("Erro ao chamar a API:", error);
    }
  };

  const handleFormSubmit = () => {
    // Lógica de manipulação do envio do formulário, se necessário
    console.log("Formulário enviado!");
  };

  return (
    <>
      <Grid>
        <Accordion.Root>
          <Accordion.Header
            toggleDetails={toggleDetails}
            showDetails={showDetails}
            title="Cadastrar nova UG"
          ></Accordion.Header>

          <Accordion.Content showDetails={showDetails}>
            <Grid>
              {/*Conteudo */}
              <AddUGForm
                usina={usina}
                onSave={handleFormValues}
                onSubmit={handleFormSubmit}
                onClose={onClose}
                onMount={onMount}
              />
            </Grid>
          </Accordion.Content>
        </Accordion.Root>
      </Grid>
    </>
  );
};

export default AdicionarUG;
